import find from 'lodash/find'
import { OrderStatusEnum } from '@ztechapps/common.contract'
import { OrderStatus } from './OrderStatus'

/**
 * Shipping finalizes the order (inventory, payment capture, shipping commit), so a forward move to Shipped is
 * confirmed first; moving back to Shipped from a later status needs no confirmation. Both lookups always run, so an
 * unknown status still throws.
 */
export const isShipConfirmationRequired = (targetStatus: OrderStatusEnum, currentStatus: OrderStatusEnum): boolean => {
  const isForward =
    find(OrderStatus, (entry) => entry.value === targetStatus).sort >=
    find(OrderStatus, (entry) => entry.value === currentStatus).sort

  return targetStatus === OrderStatusEnum.Shipped && isForward
}
